"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.priceOutputSchema = void 0;
exports.priceOutputSchema = {
    type: ['object', 'null'],
    required: [],
    properties: {
        premiumLtv: {
            type: ['number', 'null'],
            errorMessage: 'should be a number or null',
            default: 0,
        },
        highestBeaconScore: {
            type: ['number', 'null'],
            errorMessage: 'should be a number or null',
            default: 0,
        },
        loanAge: {
            type: ['number', 'null'],
            errorMessage: 'should be a number or null',
            default: 0,
        },
        borrowerTypeID: {
            type: 'number',
            minimum: 0,
            maximum: 32767,
            errorMessage: 'should be a number',
            default: 0,
        },
        feeProvincialSalesTaxAmount: {
            type: ['number', 'null'],
            errorMessage: 'should be a number or null',
            default: 0,
        },
        portfolioPremiumRate: {
            type: ['number', 'null'],
            errorMessage: 'should be a number or null',
        },
        portfolioPremiumAmount: {
            type: ['number', 'null'],
            errorMessage: 'should be a number or null',
            default: 0,
        },
        transactionalPremiumRate: {
            type: ['number', 'null'],
            errorMessage: 'should be a number or null',
            default: 0,
        },
        transactionalPremiumAmount: {
            type: ['number', 'null'],
            errorMessage: 'should be a number or null',
            default: 0,
        },
        portfolioSixYearTermRate: {
            type: ['number', 'null'],
            errorMessage: 'should be a number or null',
            default: 0,
        },
        portfolioFiveYearTermRate: {
            type: ['number', 'null'],
            errorMessage: 'should be a number or null',
            default: 0,
        },
        portfolioFourYearTermRate: {
            type: ['number', 'null'],
            errorMessage: 'should be a number or null',
            default: 0,
        },
        portfolioThreeYearTermRate: {
            type: ['number', 'null'],
            errorMessage: 'should be a number or null',
            default: 0,
        },
        portfolioTwoYearTermRate: {
            type: ['number', 'null'],
            errorMessage: 'should be a number or null',
            default: 0,
        },
        portfolioOneYearTermRate: {
            type: ['number', 'null'],
            errorMessage: 'should be a number or null',
            default: 0,
        },
        portfolioSixYearTermAmt: {
            type: ['number', 'null'],
            errorMessage: 'should be a number or null',
            default: 0,
        },
        portfolioFiveYearTermAmt: {
            type: ['number', 'null'],
            errorMessage: 'should be a number or null',
            default: 0,
        },
        portfolioFourYearTermAmt: {
            type: ['number', 'null'],
            errorMessage: 'should be a number or null',
            default: 0,
        },
        portfolioThreeYearTermAmt: {
            type: ['number', 'null'],
            errorMessage: 'should be a number or null',
            default: 0,
        },
        portfolioTwoYearTermAmt: {
            type: ['number', 'null'],
            errorMessage: 'should be a number or null',
            default: 0,
        },
        portfolioOneYearTermAmt: {
            type: ['number', 'null'],
            errorMessage: 'should be a number or null',
            default: 0,
        },
        portfolioSurchargeAmt: {
            type: ['number', 'null'],
            errorMessage: 'should be a number or null',
            default: 0,
        },
        transactionalSixYearTermRate: {
            type: ['number', 'null'],
            errorMessage: 'should be a number or null',
            default: 0,
        },
        transactionalFiveYearTermRate: {
            type: ['number', 'null'],
            errorMessage: 'should be a number or null',
            default: 0,
        },
        transactionalFourYearTermRate: {
            type: ['number', 'null'],
            errorMessage: 'should be a number or null',
            default: 0,
        },
        transactionalThreeYearTermRate: {
            type: ['number', 'null'],
            errorMessage: 'should be a number or null',
            default: 0,
        },
        transactionalTwoYearTermRate: {
            type: ['number', 'null'],
            errorMessage: 'should be a number or null',
            default: 0,
        },
        transactionalOneYearTermRate: {
            type: ['number', 'null'],
            errorMessage: 'should be a number or null',
            default: 0,
        },
        transactionalSixYearTermAmt: {
            type: ['number', 'null'],
            errorMessage: 'should be a number or null',
            default: 0,
        },
        transactionalFiveYearTermAmt: {
            type: ['number', 'null'],
            errorMessage: 'should be a number or null',
            default: 0,
        },
        transactionalFourYearTermAmt: {
            type: ['number', 'null'],
            errorMessage: 'should be a number or null',
            default: 0,
        },
        transactionalThreeYearTermAmt: {
            type: ['number', 'null'],
            errorMessage: 'should be a number or null',
            default: 0,
        },
        transactionalTwoYearTermAmt: {
            type: ['number', 'null'],
            errorMessage: 'should be a number or null',
            default: 0,
        },
        transactionalOneYearTermAmt: {
            type: ['number', 'null'],
            errorMessage: 'should be a number or null',
            default: 0,
        },
        transactionalSurchargeAmt: {
            type: ['number', 'null'],
            errorMessage: 'should be a number or null',
            default: 0,
        },
        multicomponentLtv: {
            type: ['number', 'null'],
            errorMessage: 'should be a number or null',
            default: 0,
        },
        minimumLtv: {
            type: ['number', 'null'],
            errorMessage: 'should be a number or null',
            default: 0,
        },
        maximumLtv: {
            type: ['number', 'null'],
            errorMessage: 'should be a number or null',
            default: 0,
        },
        highestOriginalLendingValue: {
            type: ['number', 'null'],
            errorMessage: 'should be a number or null',
            default: 0,
        },
        latestInterestAdjustmentDate: {
            type: ['string', 'null'],
            truncate: true,
            minLength: 0,
            maxLength: 16,
            errorMessage: 'should have maximum length of 16 characters or null',
            default: '',
        },
        latestTermExpiryDate: {
            type: ['string', 'null'],
            truncate: true,
            minLength: 0,
            maxLength: 16,
            errorMessage: 'should have maximum length of 16 characters or null',
            default: '',
        },
        sumOfAllOriginalLoanAmounts: {
            type: ['number', 'null'],
            errorMessage: 'should be a number or null',
            default: 0,
        },
        sumOfAllCurrentLoanAmounts: {
            type: ['number', 'null'],
            errorMessage: 'should be a number or null',
            default: 0,
        },
        wghtAvgCurrentLoanInterestRate: {
            type: ['number', 'null'],
            errorMessage: 'should be a number or null',
            default: 0,
        },
        longestLoanTerm: {
            type: ['number', 'null'],
            errorMessage: 'should be a number or null',
            default: 0,
        },
        wghtAvgRemainingLoanAmortization: {
            type: ['number', 'null'],
            errorMessage: 'should be a number or null',
            default: 0,
        },
        highestInterestTypeCode: {
            type: ['string', 'null'],
            truncate: true,
            minLength: 0,
            maxLength: 16,
            errorMessage: 'should have maximum length of 16 characters or null',
            default: '',
        },
    },
};
exports.default = exports.priceOutputSchema;
